<div class="inner-wrapper">
  <h2 class="header">{{header() | translate}}</h2>
  @if (bodyFirstLine) {
    <p>{{bodyFirstLine | translate}}</p>
  }
  @if (bodySecondLine) {
    <p>{{bodySecondLine | translate}}</p>
  }
  <div class="extra-content">
    <ng-content></ng-content>
  </div>
</div>
